import { render } from "./SelectNation.vue?vue&type=template&id=bce5a770"
import script from "./SelectNation.vue?vue&type=script&lang=js"
export * from "./SelectNation.vue?vue&type=script&lang=js"

import exportComponent from "F:\\ffile\\vscodeprj\\app\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__